import { render, staticRenderFns } from "./groups.pug?vue&type=template&id=9e5b8c8e&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./groups.scss?vue&type=style&index=0&id=9e5b8c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5b8c8e",
  null
  
)

export default component.exports